import { render, staticRenderFns } from "./dynamic-ads.vue?vue&type=template&id=71f2ed8a&"
import script from "./dynamic-ads.vue?vue&type=script&lang=js&"
export * from "./dynamic-ads.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-ads.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./dynamic-ads.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports